// extracted by mini-css-extract-plugin
module.exports = {"pointer":"OtherOffers_pointer__FR2hU"};